import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAddBookMutation } from '../../features/api/apiSlice';

const AddForm = () => {
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [author, setAuthor] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [rating, setRating] = useState("");
    const [price, setPrice] = useState("");
    const [featured, setFeatured] = useState(false);

    const [addBook, {isLoading, isError, isSuccess}] = useAddBookMutation()

    const resetForm = () => {
            setName("");
            setAuthor("");
            setThumbnail("");
            setPrice(0);
            setRating(0);
            setFeatured(false);
     }

     const handleSubmit = (e) => {
        e.preventDefault();
    
        const data = {
            name,
            author,
            thumbnail,
            rating : Number(rating),
            price : Number(price),
            featured
        }
    
        addBook(data)
           .then((data) => {
            if(data?.data?.id){
              toast.success("New book has been added!")  
              resetForm();
              navigate('/')

            }
            
           })
      }
    return (
        <form class="book-form" onSubmit={handleSubmit}>
                    <div class="space-y-2">
                        <label for="lws-bookName">Book Name</label>
                        <input required class="text-input" type="text" id="lws-bookName" name="name" value={name} onChange={(e) => setName(e.target.value)}/>
                    </div>

                    <div class="space-y-2">
                        <label for="lws-author">Author</label>
                        <input required class="text-input" type="text" id="lws-author" name="author" value={author} onChange={(e) => setAuthor(e.target.value)}/>
                    </div>

                    <div class="space-y-2">
                        <label for="lws-thumbnail">Image Url</label>
                        <input required class="text-input" type="text" id="lws-thumbnail" name="thumbnail" value={thumbnail} onChange={(e) => setThumbnail(e.target.value)}/>
                    </div>

                    <div class="grid grid-cols-2 gap-8 pb-4">
                        <div class="space-y-2">
                            <label for="lws-price">Price</label>
                            <input required class="text-input" type="number" id="lws-price" placeholder='0' name="price" value={price} onChange={(e) => setPrice(e.target.value)}/>
                        </div>

                        <div class="space-y-2">
                            <label for="lws-rating">Rating</label>
                            <input required class="text-input" type="number" id="lws-rating" placeholder='0 - 5' name="rating" min="1"
                                max="5" value={rating} onChange={(e) => setRating(e.target.value)}/>
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input id="lws-featured" type="checkbox" name="featured" class="w-4 h-4" checked={featured} onChange={(e) => setFeatured(!featured)}/>
                        <label for="lws-featured" class="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button type="submit" class="submit" id="lws-submit">Add Book</button>
                </form>
    );
};

export default AddForm;